import { render, staticRenderFns } from "./grid-col-widget.vue?vue&type=template&id=07e1e7bf&scoped=true&"
import script from "./grid-col-widget.vue?vue&type=script&lang=js&"
export * from "./grid-col-widget.vue?vue&type=script&lang=js&"
import style0 from "./grid-col-widget.vue?vue&type=style&index=0&id=07e1e7bf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07e1e7bf",
  null
  
)

export default component.exports